<template>
  <v-container fluid>
    <v-dialog v-model="reviewStageChecklistDialog" persistent width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Review Stage Checklist</span>
          <v-spacer></v-spacer>
          <v-btn
            @click="unselectAllChecklistItems"
            class="mr-3"
            color="primary"
          >
            <v-icon class="mr-2">mdi-selection-remove</v-icon>
            <span>unselect all</span>
          </v-btn>
          <v-btn
            @click="selectAllcheckListItems"
            class="mr-3"
            color="secondary"
          >
            <v-icon class="mr-2">mdi-check-all</v-icon>
            <span>Select all</span>
          </v-btn>
          <v-btn icon @click="reviewStageChecklistDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row v-for="item in stageChecklist" :key="item.lineNo">
            <v-col cols="12">
              <span>
                {{ item.description }}
              </span>
            </v-col>
            <v-col cols="12" style="margin-top: -2rem">
              <v-checkbox
                label="exists"
                :ref="`exist-${item.lineNo}`"
                @change="markChecklist(item)"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" style="margin-top: -2rem">
              <v-textarea
                v-model="item.Comment"
                label="Add comments"
                required
                rows="3"
                :ref="item.lineNo"
                @change="addComment(item)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveCheckListRecord"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "reviewStageChecklistDialog",
  data() {
    return {
      activeChecklistItem: 0,
      exists: false,
      checkklistInit: {
        Comment: "",
      },
      FormData: [],
    };
  },
  computed: {
    documentNo() {
      return (
        this.$store.getters["Setup/checklistDocumentNo"] ||
        this.$route.params.Code
      );
    },
    stageChecklist: {
      get() {
        return this.$store.getters["Setup/stageChecklist"];
      },
    },
    reviewStageChecklistDialog: {
      get() {
        return this.$store.getters["Setup/reviewStageChecklistDialog"];
      },
      set(value) {
        this.$store.commit("Setup/SET_REVIEW_STAGE_CHECKLIST_DIALOG", {
          state: value,
          checklist: [],
        });
      },
    },
  },
  methods: {
    saveCheckListRecord() {
      const checklistCompleted =
        this.FormData.length === this.stageChecklist.length;
      if (checklistCompleted) {
        this.$store.dispatch("Setup/submitStageChecklistRecord", this.FormData);
        this.FormData = [];
        this.reviewStageChecklistDialog = false;
      }
    },
    addComment(item) {
      let line = this.FormData.find((d) => d.lineNo === item.lineNo);
      if (line && Object.keys(line).length) {
        line.Comment = this.$refs[item.lineNo][0].value;
        this.FormData = this.FormData.filter((dt) => dt.lineNo !== line.lineNo);
        this.FormData.push(line);
      } else {
        const data = {
          documentType: item.documentType,
          documentNo: this.documentNo,
          reviewStage: item.reviewStage,
          lineNo: item.lineNo,
          description: item.description,
          exists: false,
          Comment: this.$refs[item.lineNo][0].value,
        };
        this.FormData.push(data);
      }
    },
    markChecklist(item) {
      const data = {
        documentType: item.documentType,
        documentNo: this.documentNo,
        reviewStage: item.reviewStage,
        lineNo: item.lineNo,
        description: item.description,
        exists: true,
        Comment: "",
      };
      let line = this.FormData.find((d) => d.lineNo === item.lineNo);
      if (line && Object.keys(line).length) {
        line.exists = !line.exists;
        this.FormData = this.FormData.filter((dt) => dt.lineNo !== line.lineNo);
        this.FormData.push(line);
      } else {
        this.FormData.push(data);
      }
    },
    selectAllcheckListItems() {
      this.stageChecklist.forEach((checlist) => {
        this.$refs[`exist-${checlist.lineNo}`][0].value = true;
        const data = {
          documentType: checlist.documentType,
          documentNo: this.documentNo,
          reviewStage: checlist.reviewStage,
          lineNo: checlist.lineNo,
          description: checlist.description,
          exists: this.$refs[`exist-${checlist.lineNo}`][0].value,
          Comment: "",
        };
        let line = this.FormData.find((d) => d.lineNo === checlist.lineNo);
        if (line && Object.keys(line).length) {
          line.exists = this.$refs[`exist-${checlist.lineNo}`][0].value;
          this.FormData = this.FormData.filter(
            (dt) => dt.lineNo !== line.lineNo
          );
          this.FormData.push(line);
        } else {
          this.FormData.push(data);
        }
      });
    },
    unselectAllChecklistItems() {
      this.stageChecklist.forEach((checlist) => {
        this.$refs[`exist-${checlist.lineNo}`][0].value = false;
      });
      this.FormData = [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
